import React from 'react';
import {Video, Camera, Home, HardHat, Building2, Plane, Edit, Map, Rotate3d} from 'lucide-react';

const services = [
  { icon: Video, title: "Filmagens e Fotografias Aéreas", desc: "Captação de imagens em alta resolução 4K/5.4K." },
  { icon: Building2, title: "Marketing Digital Organizacional", desc: "Valorize sua empresa com imagens aéreas profissionais." },
  { icon: Home, title: "Marketing Digital Residencial", desc: "Destaque imóveis de alto padrão para venda ou aluguel." },
  { icon: HardHat, title: "Acompanhamento de Obras", desc: "Monitoramento contínuo da evolução de construções civis." },
  { icon: Building2, title: "Vistoria de Fachadas", desc: "Inspeção segura de estruturas prediais e telhados." },
  { icon: Plane, title: "Marketing Turístico e Eventos", desc: "Cobertura aérea de eventos e pontos turísticos." },
  { icon: Edit, title: "Edição de Vídeos e Imagens", desc: "Pós-produção profissional para material finalizado." },
  { icon: Map, title: "Mapeamento e Georreferenciamento", desc: "Ortofotografia e topografia com precisão." },
  { icon: Rotate3d, title: "Fotografia 360 Graus", desc: "Imagens panorâmicas imersivas." },
];

export default function Services() {
  return (
    <section id="services" className="relative py-20 bg-gray-900">
       {/* Background Image Reuse */}
       <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed z-0 opacity-20"
        style={{ 
          backgroundImage: 'url("https://static.lumi.new/87/87dabfc34549fd1372699bd20e9469e4.png")',
        }}
      />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">Nossos Serviços</h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-400 max-w-2xl mx-auto">
            Soluções completas com tecnologia de ponta para atender sua necessidade.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white/5 backdrop-blur-sm border border-white/10 p-8 rounded-xl hover:bg-white/10 transition-all duration-300 hover:-translate-y-2"
            >
              <div className="flex items-center justify-center w-14 h-14 bg-blue-600 rounded-full mb-6 group-hover:scale-110 transition-transform">
                <service.icon className="text-white w-7 h-7" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
              <p className="text-gray-400">{service.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-blue-900/30 backdrop-blur-md rounded-2xl p-8 border border-blue-500/30">
          <div className="grid md:grid-cols-2 gap-6">
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-blue-400"></div>
                <span className="text-gray-200">Trabalhamos com aeronaves modernas, homologadas e certificadas (ANAC/DECEA).</span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-blue-400"></div>
                <span className="text-gray-200">Aeronaves seguradas (RETA) para máxima tranquilidade.</span>
              </li>
            </ul>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-blue-400"></div>
                <span className="text-gray-200">Operamos com profissionais certificados e capacitados.</span>
              </li>
              <li className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-2 h-2 mt-2 rounded-full bg-blue-400"></div>
                <span className="text-gray-200">Conformidade total com as boas práticas de segurança e LGPD.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
